import {Buffer} from "buffer";
import crypto from "crypto";
import axios, {AxiosResponse} from "axios";
import {Parameters} from "../components/Login";

export interface TokenDto {
    access_token: string
}

export class Token {
    accessCode: string | null
    constructor(accessCode: string | null) {
        this.accessCode = accessCode
    }
}

export class AuthorizationService {

    constructor() {
    }

    base64URLEncode(str: Buffer) {
        return str.toString('base64')
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=/g, '');
    }

    sha256(buffer: string) {
        return crypto.createHash('sha256').update(buffer).digest()
    }

    requestAuthorizationCode() {

        let code_verifier = this.base64URLEncode(crypto.randomBytes(32))
        window.sessionStorage.setItem("CODE_VERIFIER", code_verifier);
        let challenge = this.base64URLEncode(this.sha256(code_verifier))

        let url = process.env.REACT_APP_AUTH_SERVER_URL + "/oauth2/authorize"
        let clientId = "client"
        let redirectUri = process.env.REACT_APP_REDIRECT_URI + ""
        let scope = "openid"
        let responseType = "code"
        let responseMode = "query"
        let codeChallengeMethod = "S256"

        let authorizeURL = new URL(url)
        authorizeURL.searchParams.append("client_id", clientId)
        authorizeURL.searchParams.append("redirect_uri", redirectUri)
        authorizeURL.searchParams.append("scope", scope)
        authorizeURL.searchParams.append("response_type", responseType)
        authorizeURL.searchParams.append("response_mode", responseMode)
        authorizeURL.searchParams.append("code_challenge_method", codeChallengeMethod)
        authorizeURL.searchParams.append("code_challenge", challenge)

        window.location.replace(authorizeURL)
    }

    async getToken(parameters: Parameters): Promise<TokenDto> {
        return axios.post<any, AxiosResponse<TokenDto>>(process.env.REACT_APP_AUTH_SERVER_URL + "/oauth2/token",
            undefined,
            {
                auth: {
                    username: "client",
                    password: process.env.REACT_APP_CLIENT_SECRET + ""
                },
                params: {
                    grant_type: parameters.grant_type,
                    client_id: parameters.client_id,
                    redirect_uri: parameters.redirect_uri,
                    code_verifier: parameters.code_verifier,
                    code: parameters.code
                }
            })
            .then(res => {
                return res.data
            })
    }
}